import { render, staticRenderFns } from "./ProductFormTabFilters.vue?vue&type=template&id=91bd88ce&scoped=true"
import script from "./ProductFormTabFilters.vue?vue&type=script&lang=js"
export * from "./ProductFormTabFilters.vue?vue&type=script&lang=js"
import style0 from "./ProductFormTabFilters.vue?vue&type=style&index=0&id=91bd88ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91bd88ce",
  null
  
)

export default component.exports